var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-registry-quantity.j2"] = require( "product-registry-quantity.j2" );
dependencies["product-quantity.j2"] = require( "product-quantity.j2" );
dependencies["registry-quickshop/registry-quickshop-name.j2"] = require( "registry-quickshop/registry-quickshop-name.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-quantity-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard")) {
env.getTemplate("product-registry-quantity.j2", false, "product/templates/product-quantity-container.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
})});
}
else {
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard")) {
env.getTemplate("product-quantity.j2", false, "product/templates/product-quantity-container.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
})});
}
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity") && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard"))) {
output += "\n\n   ";
env.getTemplate("registry-quickshop/registry-quickshop-name.j2", false, "product/templates/product-quantity-container.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-quantity-container.j2"] , dependencies)